type Html2CanvasModule = typeof import('html2canvas');
type Html2CanvasDefault = Html2CanvasModule['default'];
type Html2CanvasOptions = NonNullable<Parameters<Html2CanvasDefault>[1]>;

let html2CanvasPromise: Promise<Html2CanvasDefault> | null = null;

function loadHtml2Canvas(): Promise<Html2CanvasDefault> {
    if (html2CanvasPromise === null) {
        html2CanvasPromise = import('html2canvas').then(module => module.default);
    }

    return html2CanvasPromise;
}

export async function renderHtml2Canvas(element: HTMLElement, options?: Html2CanvasOptions): Promise<HTMLCanvasElement> {
    const html2Canvas = await loadHtml2Canvas();

    return html2Canvas(element, options);
}
